import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { Avatar, Card, Typography, Grid } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import ThumbsUp from '@material-ui/icons/ThumbUpOutlined';
import RequestIcon from '@material-ui/icons/LibraryAdd';
import DeniedIcon from '@material-ui/icons/LayersClear';
import { NoteAddRounded } from '@material-ui/icons';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import Money from '@material-ui/icons/Money';
import { makeStyles } from '@material-ui/styles';
import { blue, green, orange, indigo, red, common } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  card: {
    marginLeft: theme.spacing(2),
    flexGrow: 1,
    display: 'flex',
    padding: theme.spacing(2),
    alignItems: 'center'
  },
  date: {
    marginLeft: 'auto',
    flexShrink: 0
  },
  avatar: {
    color: common.white
  },
  avatarBlue: {
    backgroundColor: blue[500]
  },
  avatarGreen: {
    backgroundColor: green[500]
  },
  avatarOrange: {
    backgroundColor: orange[500]
  },
  avatarIndigo: {
    backgroundColor: indigo[500]
  },
  avatarRed: {
    backgroundColor: red[500]
  }
}));

const avatarsMap = {
  ClaimFiled: {
    icon: GetAppIcon,
    className: 'avatarBlue'
  },
  ClaimAutoAuthorized: {
    icon: DashboardIcon,
    className: 'avatarIndigo'
  },
  ClaimNotAutorized: {
    icon: DashboardIcon,
    className: 'avatarIndigo'
  },
  ClaimAuthorized: {
    icon: ThumbsUp,
    className: 'avatarGreen'
  },
  documentUploaded: {
    icon: RequestIcon,
    className: 'avatarBlue'
  },
  ClaimPartiallyDenied: {
    icon: DeniedIcon,
    className: 'avatarRed'
  },
  ClaimDenied: {
    icon: DeniedIcon,
    className: 'avatarRed'
  },
  ClaimPaid: {
    icon: Money,
    className: 'avatarGreen'
  },
  ClaimNoteAdded: {
    icon: NoteAddRounded,
    className: 'avatarGreen'
  },
  ClaimNoteUpdated: {
    icon: NoteAddRounded,
    className: 'avatarOrange'
  },
  ClaimNoteDeleted: {
    icon: NoteAddRounded,
    className: 'avatarRed'
  },
  ClaimApproved: {
    icon: ThumbsUp,
    className: 'avatarGreen'
  },
  ClaimProcessing: {
    icon: DashboardIcon,
    className: 'avatarIndigo'
  },
  Unknown: {
    icon: HelpOutlineOutlinedIcon,
    className: 'avatarBlue'
  }
};

function Activity({ activity, className, ...rest }) {
  const classes = useStyles();
  const avatar = avatarsMap[activity.eventType] ?? avatarsMap['Unknown'];

  const getCreatedDate = () => {
    return moment.utc(activity.dateCreated).local().format('YYYY-MM-DD HH:mm');

  };

  return (
    <Grid Container className={clsx(classes.root, className)} {...rest} >
      <Grid item >
        <Avatar className={clsx(classes.avatar, classes[avatar.className])}>
          <avatar.icon />
        </Avatar>
      </Grid>
      <Grid item xs={10}>
        <Card className={classes.card}>
          <Typography variant="body1" color="textPrimary">
            {activity.eventDescription}
          </Typography>
          <Typography className={classes.date} variant="caption">
            {moment(getCreatedDate()).fromNow()}
          </Typography>
        </Card>
      </Grid>
    </Grid>
  );
}

Activity.propTypes = {
  activity: PropTypes.object.isRequired,
  className: PropTypes.string
};

export default Activity;
